<div class="ppl-nav ppl-nav-tabs collapse d-md-flex">
    <div *ngFor="let section of sections;" class="ppl-nav-item">
        <a class="ppl-nav-link" (click)="onSectionSelection(section)" [class.active]="section === selectedSection"
            href="javascript:void(0)">
            {{ section }}
        </a>
    </div>
</div>
@if(showSummary){
<ppl-ignored-timesheets-summary
    [ignoredTimesheetSummaryData]="ignoredTimesheetSummaryData"></ppl-ignored-timesheets-summary>
}
@else {
<ppl-ignored-timesheets-data [ignoredTimesheetData]="ignoredTimesheetData" [selectedBatchId]="selectedBatchId"></ppl-ignored-timesheets-data>
}